var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"starry-night"},[_c('div',{style:({ transform: ("translateY(" + (this.offset) + "px)") })},[_c('img',{attrs:{"src":_vm.stars}}),_c('img',{attrs:{"src":_vm.stars}})])])}
var staticRenderFns = []

export { render, staticRenderFns }